export default __webpack_public_path__ + "static/media/logo_2024_transparent.c09cf5e2.png";